import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Apollo } from 'apollo-angular';
import { ClienteService } from 'src/app/services/cliente.service';
import { LoginService } from 'src/app/services/login.service';

import {PerfilClienteComponent} from "../../../portal-cliente/perfil/perfil-cliente/perfil-cliente.component"

@Component({
  selector: 'app-user-cliente',
  templateUrl: './user-cliente.component.html',
  styleUrls: ['./user-cliente.component.scss']
})
export class UserClienteComponent implements OnInit {

  public userLogged: any
  cliente:any

  constructor(public dialog: MatDialog, loginService: LoginService, private clienteService: ClienteService, private apollo:Apollo) {
    this.userLogged = loginService.getUserData()
  }

  ngOnInit(): void {
    this.getClienteById()
  }

  openDialogCliente() {
    this.dialog.open(PerfilClienteComponent);
  }

  getClienteById(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.cliente = data.cliente
        console.log(this.cliente)

      })
  }

}
